import { transform, isEqual, isObject } from 'lodash'

export const deepObjectDiff = (object, base) => {
  function changes(object, base) {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value
      }
    })
  }

  return changes(object, base)
}

export const optionRendererRunner = (choice) => `${choice.firstname} ${choice.lastname}`
